import { Component } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent {

  constructor(private navigationService: NavigationService) {
    //this.navigationService.hide = true;
  }

  toggle() {
    this.navigationService.hide = !this.navigationService.hide;
  }
}
